export var states = [
    { value: 'us', label: 'None (Federal)' },
    { value: 'ca', label: 'California' },
    { value: 'tx', label: 'Texas' },
    { value: 'ot', label: 'Other' },
];
